module.exports = __webpack_public_path__ + "582a7c593488aa0dadac01e0c2665ac3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-26.png
// module id = 1607
// module chunks = 0